import { doc, runTransaction, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

const DEFAULT_PREFIX = 'VERA';

/**
 * True for legacy timestamp badges like `USER-1785356353953` (a prefix
 * followed by an epoch-millis number). Clean badges (VERA-001, RBT-002,
 * ADMIN-001, SPR-001) never have a 12+ digit tail, so they're preserved.
 */
export function isTimestampBadge(badge?: string | null): boolean {
  if (!badge) return false;
  return /-\d{12,}$/.test(badge.trim());
}

/**
 * Allocate the next sequential badge number, e.g. VERA-001, VERA-002.
 * Uses a Firestore transaction on counters/badgeNumber so concurrent user
 * creations never collide.
 */
export async function nextBadgeNumber(prefix: string = DEFAULT_PREFIX): Promise<string> {
  const ref = doc(db, 'counters', 'badgeNumber');
  const seq = await runTransaction(db, async (tx) => {
    const snap = await tx.get(ref);
    const current = snap.exists() ? Number(snap.data().value) || 0 : 0;
    const next = current + 1;
    tx.set(
      ref,
      { value: next, updatedAt: Timestamp.fromDate(new Date()) },
      { merge: true }
    );
    return next;
  });
  return `${prefix}-${String(seq).padStart(3, '0')}`;
}
